module.exports = __webpack_public_path__ + "img/intro-screen-bg-orange.9cc34580.png";